module.exports = __webpack_public_path__ + "static/media/Simon-Miller-Multicolor-S801-Bonsai-15-Cm-Lyst.9d54db67.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/bags/Simon-Miller-Multicolor-S801-Bonsai-15-Cm-Lyst.png
// module id = 227
// module chunks = 0